module.exports = __webpack_public_path__ + "static/media/tick-white.f95f1b4f.svg";